import React, { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Row, Col } from 'reactstrap';
import { noop } from 'lodash-es';
import {
  REPORT,
  TRADE_IN_VALUE,
  APPRAISER_REPORT_CREATIVE_ID,
} from 'site-modules/shared/constants/appraisal/appraisal';
import { AppraisalReportStepExtendedPrices } from 'site-modules/shared/components/appraisal/trade-in-appraiser-steps/appraisal-report-step-extended/appraisal-report-extended-prices';
import { LicensePlateAndVinStepAsync } from 'site-modules/shared/components/appraisal/trade-in-appraiser-steps/license-plate-and-vin-step/license-plate-and-vin-step-async';
import { AppraisalReportUserTestimonials } from 'site-modules/shared/components/appraisal/trade-in-appraiser-steps/appraisal-report-step/appraisal-report-step-user-testimonials';

export class AppraisalReportExtended extends PureComponent {
  static propTypes = {
    getVehicleData: PropTypes.func.isRequired,
    changeStep: PropTypes.func.isRequired,
    updateStepsState: PropTypes.func.isRequired,
    stepId: PropTypes.string,
    creativeId: PropTypes.string,
    selectedReportType: PropTypes.string,
    zipCode: PropTypes.string,
    color: PropTypes.shape({}),
    condition: PropTypes.string,
    mileage: PropTypes.string,
    options: PropTypes.arrayOf(PropTypes.shape({})),
    vin: PropTypes.string,
    totalPrices: PropTypes.shape({}),
    allConditionPricing: PropTypes.shape({}),
    emailReportStatus: PropTypes.string,
    resetEmailReportStatus: PropTypes.func,
    isMobile: PropTypes.bool,
    showExteriorColor: PropTypes.bool,
    showAddEquipment: PropTypes.bool,
    showReportPricesOnly: PropTypes.bool,
    modsId: PropTypes.string,
    /** Escape Hatch */
    isEscapeHatch: PropTypes.bool,
    licensePlateAndVinProps: PropTypes.shape({}),
    offerType: PropTypes.string,
  };

  static defaultProps = {
    stepId: REPORT,
    creativeId: APPRAISER_REPORT_CREATIVE_ID,
    selectedReportType: TRADE_IN_VALUE,
    zipCode: '',
    color: {},
    condition: '',
    mileage: '',
    options: [],
    vin: '',
    emailReportStatus: '',
    resetEmailReportStatus: noop,
    totalPrices: {},
    allConditionPricing: {},
    isMobile: false,
    showExteriorColor: false,
    showAddEquipment: false,
    showReportPricesOnly: false,
    modsId: '',
    /** Escape Hatch */
    isEscapeHatch: false,
    licensePlateAndVinProps: {},
    offerType: '',
  };

  render() {
    const {
      getVehicleData,
      changeStep,
      updateStepsState,
      totalPrices,
      allConditionPricing,
      // optional below
      selectedReportType,
      stepId,
      creativeId,
      zipCode,
      color,
      condition,
      mileage,
      options,
      vin,
      emailReportStatus,
      resetEmailReportStatus,
      isMobile,
      showExteriorColor,
      showAddEquipment,
      showReportPricesOnly,
      modsId,
      /** Escape Hatch */
      isEscapeHatch,
      licensePlateAndVinProps,
      offerType,
    } = this.props;
    const renderExtendedPrices = () => (
      <>
        <AppraisalReportStepExtendedPrices
          changeStep={changeStep}
          stepId={stepId}
          totalPrices={totalPrices}
          allConditionPricing={allConditionPricing}
          emailReportStatus={emailReportStatus}
          resetEmailReportStatus={resetEmailReportStatus}
          creativeId={creativeId}
          selectedReportType={selectedReportType}
          updateStepsState={updateStepsState}
          condition={condition}
          isMobile={isMobile}
          getVehicleData={getVehicleData}
          mileage={mileage}
          color={color}
          vin={vin}
          zipCode={zipCode}
          showExteriorColor={showExteriorColor}
          showAddEquipment={showAddEquipment}
          offerType={offerType}
          isEscapeHatch={isEscapeHatch}
          optionIds={options.map(({ id }) => id)}
          modsId={modsId}
        />
      </>
    );

    if (showReportPricesOnly) {
      return renderExtendedPrices();
    }

    return (
      <Fragment>
        {isEscapeHatch && (
          <Row className="appraisal-report-step-head">
            <Col xs={12}>
              <LicensePlateAndVinStepAsync
                {...licensePlateAndVinProps}
                isMobile={isMobile}
                isEscapeHatch={isEscapeHatch}
              />
            </Col>
          </Row>
        )}
        {isEscapeHatch && (
          <div className={classNames({ 'pe-2': !isMobile })}>
            <AppraisalReportUserTestimonials isMobile={isMobile} className="mb-2" />
          </div>
        )}
        {renderExtendedPrices()}
        {isEscapeHatch && (
          <Fragment>
            <hr className="my-2" />
            <LicensePlateAndVinStepAsync
              {...licensePlateAndVinProps}
              isMobile={isMobile}
              isEscapeHatch={isEscapeHatch}
              isSecondary
            />
          </Fragment>
        )}
      </Fragment>
    );
  }
}
